module.exports = __webpack_public_path__ + "static/media/default_banner.229cbe52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default_banner.png
// module id = 1878
// module chunks = 0